import LogService from "../services/log.service";

function log(event, message, context) {
  console.log(message);
  LogService.enqueue("info", event, message, context);
}

function warn(event, message, context) {
  console.warn(message);
  LogService.enqueue("warn", event, message, context);
}

function error(event, message, context) {
  console.error(message);
  LogService.enqueue("error", event, message, context);
}

export default { log, warn, error };
